import type { ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import type { ShippingService } from "../../../hooks/usePixiWizardState";
import { AddressForm } from "../AddressForm";
import type { AddressBindings } from "./BillingSection";
import { SectionCard } from "./SectionCard";
import { ShippingMethodField } from "./ShippingMethodField";

export interface ShippingSectionProps extends AddressBindings {
  /** Rendered between the contact and address groups (the unsupported warning). */
  warning?: ReactNode;
  /** When true, the address fields are read-only (mirroring the billing address). */
  disabled?: boolean;
  /** Selected shipping service, rendered as the form's last field. */
  shippingService: ShippingService;
  onShippingServiceChange: (service: ShippingService) => void;
}

/**
 * Shipping Information card: the address form (Country only, no State), with the
 * shipping-method (Standard / Express) dropdown as its last field. An optional
 * `warning` slot renders between the contact and address groups for the
 * unsupported-shipping-country case.
 */
export function ShippingSection({
  values,
  onChange,
  onBlur,
  error,
  warning,
  disabled,
  shippingService,
  onShippingServiceChange,
}: ShippingSectionProps) {
  return (
    <SectionCard
      testId="shipping-card"
      title={
        <FormattedMessage
          id="pixi_wizard.payment_shipping.shipping.title"
          defaultMessage="Shipping Information"
        />
      }
    >
      <AddressForm
        values={values}
        includeState={false}
        testIdPrefix="shipping"
        onChange={onChange}
        onBlur={onBlur}
        error={error}
        disabled={disabled}
        addressSlot={warning}
        footerSlot={
          <ShippingMethodField
            value={shippingService}
            onChange={onShippingServiceChange}
          />
        }
      />
    </SectionCard>
  );
}
